import React from 'react';

const MasterData1 = () => {
    return(
        <div>123</div>
    )
}

export default MasterData1;
